import script from "./AppendHomeworkPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppendHomeworkPage.vue?vue&type=script&setup=true&lang=ts"

import "./AppendHomeworkPage.vue?vue&type=style&index=0&id=f817ed04&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f817ed04"]])

export default __exports__